import { emptyAddress } from './address';

export type HaspCodeResponse = Components.Responses.HaspCodeResponse;

export type HaspCodeFields = Components.Schemas.HaspCodeFields;
export type HaspCode = Components.Schemas.HaspCode;
export type HaspCodeReason = Components.Schemas.HaspCodeReason;

export const emptyHaspCode = (): HaspCodeFields => ({
	id: '',
	deviceId: '',
	reason: '',
	creatorId: '',
	creatorCompanyId: '',
	utcCreateDate: '',
	utcValidDate: '',
	firstName: '',
	lastName: '',
	email: '',
	mobilePhoneNumber: '',
	propertyName: '',
	deviceLocation: '',
	address: emptyAddress(),
	removeDevice: true,
	newLocation: '',
});
